
// src/web/components/division-delete-panel.jsx

import React from 'react'
import connect from '../../connects/division-delete-panel'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
} from 'react-toolbox/lib/button'
import Checkbox from 'react-toolbox/lib/checkbox'
import theme from './themes/flat-card.css'
import ConfirmDialog from './confirm-dialog.jsx'


class DivisionDeletePanel extends React.Component {
  state = { deleteConfirm: false, deleteCheck: false }
  toggleConfirmDialog = () => this.setState({ deleteConfirm: !this.state.deleteConfirm })
  onCancel = () => {
    this.setState({ deleteConfirm: !this.state.deleteConfirm, deleteCheck: !this.state.deleteCheck })
  }
  deleteDivision = () => {
    this.toggleConfirmDialog()
    this.props.deleteDivision()
  }

  onCheck = () => {
    this.setState({ deleteCheck: !this.state.deleteCheck })
  }
  render() {
    const {
      t,
    } = this.props

    return(
      <Card theme={theme}>
        <CardText>
            <p style={{ fontSize: 16, color: 'black', marginBottom: 5 }}>
              {t('label:Move to trash')}
            </p>
            <p style={{ fontSize: 16, color: 'black', marginBottom: 5 }}>
              {t('label:are_you_sure_you_want_to_move_the_division_to_trash')}
            </p>
            <Checkbox
              theme={theme}
              className='deleteCheck'
              checked={this.state.deleteCheck}
              onChange={this.onCheck}
              label={t('label:this_operation_will_affect_all_users_participating_in_the_division')} />
              <div style={{ marginLeft: 28}}>{t('label:complete_deletion_restoration_explanation')}</div>
        </CardText>
        <CardActions>
          <Button raised primary
            type="submit"
            style={{ width: '100%' }}
            label={t('label:Move to trash')}
            disabled={!this.state.deleteCheck}
            onClick={this.toggleConfirmDialog}
          />
        </CardActions>
        <ConfirmDialog key="dialog"
          open={this.state.deleteConfirm}
          title={t('label:are_you_sure_you_want_to_move_the_division_to_trash')}
          description={<div style={{flexDirection: 'column'}}>
            <div>{t('label:this_operation_will_affect_all_users_participating_in_the_division')}</div>
            <div>{t('label:complete_deletion_restoration_explanation')}</div>
          </div>}
          yesLabel={t('label:Move to trash')}
          noLabel={t('label:取り消し')}
          onNo={this.onCancel}
          onYes={() => this.deleteDivision()}/>
      </Card>
    )
  }
}

export const RawDivisionDeletePanel = DivisionDeletePanel
export default connect(DivisionDeletePanel)



// WEBPACK FOOTER //
// ./src/web/components/division-delete-panel.jsx